import type {FormFieldValidation} from '../../../../schemas/contentful/contentTypes/formFieldValidation'
import {
  DEFAULT_VALIDATION_MESSAGES,
  FormValidationSchemas,
  GENERIC_FALLBACK,
  type ValidationBody,
} from '../../../forms/Form/validations'

/**
 * Maps a Contentful `formFieldValidation` entry to the schema-only catalog and resolves its message.
 * Contentful is the source of truth for the copy: the entry's `errorMessage` wins when present,
 * otherwise we fall back to the per-validation default (a temporary stepping stone during the
 * content migration), and finally to the generic message.
 */
export function getValidation(validation: FormFieldValidation): ValidationBody {
  const {name} = validation.fields
  const schema = FormValidationSchemas[name]
  const customMessage = validation.fields.errorMessage
  const message =
    typeof customMessage === 'string' && customMessage.trim().length > 0
      ? customMessage
      : (DEFAULT_VALIDATION_MESSAGES[name] ?? GENERIC_FALLBACK)

  return {message, schema}
}
